module.exports = new __parcel__URL__("clouds-darkmode.cc48ed71.svg").toString();